import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year2/Spring/Money/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'Money',
  field: 'Measurement',
  weeks: [1, 2],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(/* webpackChunkName: "Year2/Spring/Money/1CountMoneyPence" */ './1CountMoneyPence')
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Spring/Money/2CountMoneyPoundsNotesAndCoins" */ './2CountMoneyPoundsNotesAndCoins'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Spring/Money/3CountMoneyPoundsAndPence" */ './3CountMoneyPoundsAndPence'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Spring/Money/4ChooseNotesAndCoins" */ './4ChooseNotesAndCoins'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Spring/Money/5MakeTheSameAmount" */ './5MakeTheSameAmount'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Spring/Money/6CompareAmountsOfMoney" */ './6CompareAmountsOfMoney'
        )
    }),
    // Step 7
    newSmallStepContent({
      ...BlockModel.smallSteps[6],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Spring/Money/7CalculateWithMoney" */ './7CalculateWithMoney'
        )
    }),
    // Step 8
    newSmallStepContent({
      ...BlockModel.smallSteps[7],
      module: () => import(/* webpackChunkName: "Year2/Spring/Money/8MakeAPound" */ './8MakeAPound')
    }),
    // Step 9
    newSmallStepContent({
      ...BlockModel.smallSteps[8],
      module: () => import(/* webpackChunkName: "Year2/Spring/Money/9FindChange" */ './9FindChange')
    }),
    // Step 10
    newSmallStepContent({
      ...BlockModel.smallSteps[9],
      module: () =>
        import(/* webpackChunkName: "Year2/Spring/Money/10TwoStepProblems" */ './10TwoStepProblems')
    })
  ]
});
export default Block;
